import { render, staticRenderFns } from "./CustomFacets.vue?vue&type=template&id=60974bbc&scoped=true"
import script from "./CustomFacets.vue?vue&type=script&lang=js"
export * from "./CustomFacets.vue?vue&type=script&lang=js"
import style0 from "./CustomFacets.vue?vue&type=style&index=0&id=60974bbc&prod&lang=scss"
import style1 from "./CustomFacets.vue?vue&type=style&index=1&id=60974bbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60974bbc",
  null
  
)

export default component.exports